// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 582) return "js/modal.js";
	if (chunkId === 787) return "js/edit-picture.js";
	if (chunkId === 293) return "js/add-picture.js";
	if (chunkId === 152) return "js/image-search.js";
	if (chunkId === 622) return "js/image-repository.js";
	if (chunkId === 302) return "js/add-picture-modal.js";
	if (chunkId === 732) return "js/add-translation-modal.js";
	if (chunkId === 161) return "js/edit-keyword-modal.js";
	if (chunkId === 390) return "js/picture-dictionary.js";
	if (chunkId === 423) return "js/save-theme-modal.js";
	if (chunkId === 317) return "js/image-repository-management.js";
	if (chunkId === 37) return "js/demo-dictionary.js";
	if (chunkId === 264) return "js/demo-unit-list.js";
	if (chunkId === 634) return "js/user-image-requet-table.js";
	if (chunkId === 460) return "js/admin-theme-unit-list.js";
	if (chunkId === 775) return "js/request-image.js";
	if (chunkId === 284) return "js/image-request-table.js";
	if (chunkId === 232) return "js/demo-user-table.js";
	if (chunkId === 296) return "js/manage-languages.js";
	if (chunkId === 618) return "js/add-language-button.js";
	if (chunkId === 816) return "js/state-selector.js";
	if (chunkId === 490) return "js/city-selector.js";
	if (chunkId === 530) return "js/grade-level-selector.js";
	if (chunkId === 430) return "js/ela-video.js";
	if (chunkId === 563) return "js/campaign-form.js";
	if (chunkId === 963) return "js/campaigns-table.js";
	if (chunkId === 402) return "js/pointer-arrow-right.js";
	if (chunkId === 249) return "js/pop-video.js";
	if (chunkId === 703) return "js/button-video.js";
	if (chunkId === 689) return "js/user-downloads-modal.js";
	if (chunkId === 461) return "js/button-event.js";
	if (chunkId === 305) return "js/success-notification.js";
	if (chunkId === 329) return "js/ela-input-tag.js";
	// return url for filenames based on template
	return undefined;
};